import React from 'react';
import PropTypes from 'prop-types';
import { DeliveryInstallationDetailsPlaceholder } from './DeliveryInstallationDetailsPlaceholder';
import './delivery-installation-details.scss';

export const DeliveryInstallationDetails = ({ applianceText, loading }) => {
  if (loading) {
    return <DeliveryInstallationDetailsPlaceholder />;
  }
  if (!applianceText) {
    return null;
  }

  return (
    <div className="delivery-and-installation-details" data-testid="delivery-and-installation-details-test-id">
      <h2 className="delivery-and-installation-details__header">Please ensure the following prior to delivery:</h2>
      <ul className="delivery-and-installation-details__text">
        {applianceText.map((text, i) => {
          return (
            <li className="delivery-and-installation-details__appliance-text" key={i}>{text}</li>
          );
        })}
      </ul>
    </div>
  );
};

DeliveryInstallationDetails.propTypes = {
  applianceText: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool.isRequired
};

DeliveryInstallationDetails.defaultProps = {
  applianceText: null
};